import type { Ref } from '@/composition/vue/compositionApi'

export const detailsTableLabelSizeSymbol = Symbol('detailsTableLabelSize')
export type DetailsTableLabelSize = Ref<string | undefined>
